module.exports = __webpack_public_path__ + "static/lframe-brokers-edeff13737246a9091d370fb34bf80b4.png";